import { render, staticRenderFns } from "./CardModule.vue?vue&type=template&id=11f1bc08"
import script from "./CardModule.vue?vue&type=script&lang=js"
export * from "./CardModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports